import { lazy } from "react";

const RELOADED_AT_KEY = "lazy-page-reloaded-at";
const RELOAD_WINDOW_MS = 60_000; // one reload per minute at most: a page that keeps failing shows its error

// A lazily loaded page. After a deploy swaps the build, a tab still running the old bundle asks for
// page files that no longer exist; it reloads once to pick up the new build instead of failing.
export const lazyPage = (load) =>
  lazy(() =>
    load().catch((err) => {
      let recent = true;
      try {
        recent = Date.now() - Number(sessionStorage.getItem(RELOADED_AT_KEY) || 0) < RELOAD_WINDOW_MS;
        if (!recent) {
          sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
        }
      } catch {
        /* storage blocked: never reload, so a real failure cannot loop */
      }
      if (recent) {
        throw err;
      }
      window.location.reload();
      return new Promise(() => {}); // the reload replaces the page
    })
  );
